import { noteMdToHtml } from "./notes";
import { flashcardMdToHtml } from "./flashcards";
import showdown from "showdown";
import { getPlainTextFromContent } from "../../helpers/getPlainTextFromContent";
import { vdom } from "zeed-dom";
type ContentType = "note" | "flashcard";

const converter = new showdown.Converter({
    tables: true,
    headerLevelStart: 2,
    simpleLineBreaks: true,
    disableForced4SpacesIndentedSublists: true,
});

export const mdToHtml = (content: string, _type?: ContentType) => {
    return converter.makeHtml(content);
};

export const htmlToMd = (html: string, overrideDom = false) => {
    try {
        const content = converter.makeMarkdown(html, overrideDom ? vdom() : undefined);

        // check if tables are parsed incorrectly, and throw an error if so
        const emptyTableRow = "|  |";
        const emptyRowCount = (content.match(new RegExp(emptyTableRow, "g")) || []).length;
        if (emptyRowCount > 5) {
            // biome-ignore lint: style/noConsole
            console.error("Tables are parsed incorrectly", content);
            throw new Error("Tables are parsed incorrectly");
        }

        return content;
    } catch (e) {
        // biome-ignore lint: style/noConsole
        console.error("Error parsing html to markdown", e);
        return getPlainTextFromContent({ content: html, type: "note" });
    }
};

export const mdToHtmlOLD = (content: string, type: ContentType) => {
    try {
        return type === "note" ? noteMdToHtml(content) : flashcardMdToHtml(content);
    } catch (error) {
        // biome-ignore lint: style/noConsole
        console.error("Error parsing markdown to html", error);
        return `<p>${content}</p>`;
    }
};
